import clsx from 'clsx';

type PlanColorType =
  'trial' | 'probation' | 'plus' | 'pro' | 'job_only' | 'legacy' | 'expired' | 'unknown';
type AdminPlanTagSize = 'sm' | 'lg';

const planColorConfig: Record<PlanColorType, { bg: string; dot: string }> = {
  trial: { bg: 'bg-[#e8fff8]', dot: 'bg-[#49d7ad]' },
  probation: { bg: 'bg-[#e8fff8]', dot: 'bg-[#49d7ad]' },
  plus: { bg: 'bg-[#ffefea]', dot: 'bg-[#f1835b]' },
  pro: { bg: 'bg-[#eaf0ff]', dot: 'bg-[#5f88f0]' },
  job_only: { bg: 'bg-[#ffffef]', dot: 'bg-[#f5f900]' },
  legacy: { bg: 'bg-[#fbeaff]', dot: 'bg-[#c840e9]' },
  expired: { bg: 'bg-[#eee]', dot: 'bg-[#696969]' },
  unknown: { bg: 'bg-[#eee]', dot: 'bg-[#696969]' },
};

const sizeConfig: Record<AdminPlanTagSize, { dot: string; text: string; padding: string }> = {
  sm: {
    dot: 'size-2',
    text: 'text-xs font-bold text-[#333]',
    padding: 'px-2 py-0.5',
  },
  lg: {
    dot: 'size-3',
    text: 'text-xl font-bold text-[#333]',
    padding: 'px-3 py-1',
  },
};

function resolveColorType(planType: string | null | undefined): PlanColorType {
  if (!planType) return 'unknown';
  return (planColorConfig[planType as PlanColorType] ? planType : 'unknown') as PlanColorType;
}

type AdminPlanTagProps = {
  /** プラン名（表示用） */
  plan: string | null | undefined;
  /** plan_type（色の判定用） */
  planType?: string | null | undefined;
  size?: AdminPlanTagSize;
  className?: string;
};

/** プランタグ（ドット + ラベルのピル型バッジ） */
export default function AdminPlanTag({
  plan,
  planType,
  size = 'sm',
  className,
}: AdminPlanTagProps) {
  const colorType = resolveColorType(planType);
  const color = planColorConfig[colorType];
  const sizing = sizeConfig[size];

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full',
        sizing.padding,
        color.bg,
        className
      )}
    >
      <span className={clsx('rounded-full', sizing.dot, color.dot)} />
      <span className={sizing.text}>{plan ?? '----'}</span>
    </span>
  );
}
